import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonusTotal, bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-plum-800 py-16 text-white md:py-24" data-id="element-14" data-mp="pj6c83lngiqh">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-15" data-mp="au1raenh00eo">
        <header className="mx-auto max-w-narrow text-center" data-id="element-16" data-mp="ftwm2tad9a50">
          <h2 className="inline-flex flex-wrap items-center justify-center gap-3 font-display text-[2rem] font-extrabold leading-tight tracking-tight text-white md:text-5xl" data-id="element-17" data-mp="fs3cp68dcbtb">
            <GiftIcon className="h-8 w-8 text-gold-300 md:h-10 md:w-10" aria-hidden="true" data-id="element-18" data-mp="5wrw0ideguix" />
            Y además recibís 3 bonos exclusivos
          </h2>
          <p className="mt-5 text-lg text-rose-100 md:text-xl" data-id="element-19" data-mp="3t0g6egxh6gen">
            Solo por esta campaña, incluidos sin costo con tu Protocolo.
          </p>
        </header>

        <ul className="mt-12 grid gap-5 md:mt-16 lg:grid-cols-3" data-id="element-20" data-mp="1m85m1n1vtsks">
          {bonuses.map(bonus => <li key={bonus.tag} className="flex h-full flex-col rounded-2xl bg-plum-900 p-6 ring-1 ring-plum-700 md:p-7" data-id="element-21" data-mp="1r78qb5a1furp">
              <span className="inline-flex w-fit items-center rounded-lg bg-gold-400 px-3 py-1 font-display text-xs font-extrabold uppercase tracking-[0.12em] text-plum-900" data-id="element-22" data-mp="3dek2r2e3mbk8">
                {bonus.tag}
              </span>
              <h3 className="mt-5 font-display text-xl font-extrabold leading-snug tracking-tight text-white" data-id="element-23" data-mp="3n5y6xngzvzjp">
                {bonus.title}
              </h3>
              <p className="mt-1 font-display text-sm font-bold text-rose-300" data-id="element-24" data-mp="2uh91xdctja2o">{bonus.subtitle}</p>
              <p className="mt-4 text-rose-100" data-id="element-25" data-mp="38giiwf8um87p">{bonus.lead}</p>
              <p className="mt-3 font-display font-extrabold tracking-tight text-gold-300" data-id="element-26" data-mp="33h5p1ajk80vm">
                {bonus.promise}
              </p>

              <ul className="mt-5 space-y-2.5" data-id="element-27" data-mp="nozw8jlspw5f">
                {bonus.includes.map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-rose-100" data-id="element-28" data-mp="ipwvvcgrge3s">
                    <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-mint-400" aria-hidden="true" data-id="element-29" data-mp="3chv4fnymz8ll" />
                    <span data-id="element-30" data-mp="3hgybfdy6fow7">{item}</span>
                  </li>)}
              </ul>

              <p className="mt-auto flex items-center gap-3 pt-7" data-id="element-31" data-mp="3lknvpr7tjkbf">
                <span className="text-sm text-rose-300 line-through" data-id="element-32" data-mp="3qifnml8gr6fm">Valor: {bonus.value}</span>
                <span className="rounded-lg bg-mint-500/15 px-3 py-1 font-display text-sm font-extrabold uppercase text-mint-400 ring-1 ring-mint-500/40" data-id="element-33" data-mp="2tseyum83gpyb">
                  Hoy incluido
                </span>
              </p>
            </li>)}
        </ul>

        <p className="mx-auto mt-12 w-fit rounded-2xl bg-plum-900 px-6 py-4 text-center font-display text-lg font-extrabold uppercase tracking-[0.08em] text-gold-300 ring-1 ring-gold-500/40 md:text-xl" data-id="element-34" data-mp="32rsddtb2s4pw">
          Valor total de los 3 bonos: {bonusTotal}
        </p>
      </div>
    </section>;
}